import { request } from './request'
import { useServerFetch } from '../composables/useServerFetch'
import { useEnvApi } from '../composables/useEnvApi'

export const APP_DOWNLOAD_LINKS_API_PATH = '/api/v4/bit/web/down/app-link'

export type AppDownloadLinksResponse = {
  appStoreUrl: string
  googlePlayUrl: string
  androidApkUrl: string
  h5down: string
}

export const FALLBACK_DOWNLOAD_LINKS: AppDownloadLinksResponse = {
  appStoreUrl: '',
  googlePlayUrl: '',
  androidApkUrl: '',
  h5down: 'https://apph5.tech009.com/mobile/download',
}

type AppDownloadLinksPayload = {
  data?: AppDownloadLinksResponse
}

/**
 * 判断接口响应是否为带 data 包裹的结构。
 * @param response 待判断的接口响应。
 * @returns 是否为 data 包裹结构。
 */
const isDownloadLinksPayload = (
  response: AppDownloadLinksResponse | AppDownloadLinksPayload | null,
): response is AppDownloadLinksPayload => {
  return !!response && typeof response === 'object' && 'data' in response
}

/**
 * 规范化下载地址，缺失字段时回退到默认值。
 * @param response 下载地址接口响应。
 * @returns 可直接渲染的下载地址。
 */
export const normalizeDownloadLinks = (
  response: AppDownloadLinksResponse | AppDownloadLinksPayload | null,
): AppDownloadLinksResponse => {
  const res: AppDownloadLinksResponse | null = isDownloadLinksPayload(response) ? (response.data ?? null) : response

  return {
    appStoreUrl: res?.appStoreUrl || FALLBACK_DOWNLOAD_LINKS.appStoreUrl,
    googlePlayUrl: res?.googlePlayUrl || FALLBACK_DOWNLOAD_LINKS.googlePlayUrl,
    androidApkUrl: res?.androidApkUrl || FALLBACK_DOWNLOAD_LINKS.androidApkUrl,
    h5down: res?.h5down || FALLBACK_DOWNLOAD_LINKS.h5down,
  }
}

export const getAppDownloadLinks = async (): Promise<AppDownloadLinksResponse | null> => {
  const api = useEnvApi()
  const requestConfig = {
    baseURL: import.meta.server ? api.wikibitBffGo : api.v4,
    url: APP_DOWNLOAD_LINKS_API_PATH,
    method: 'GET' as const,
  }
  const response = import.meta.server
    ? await useServerFetch<AppDownloadLinksResponse>(requestConfig)
    : await request<unknown, AppDownloadLinksResponse>(requestConfig)

  return response ?? null
}
